import { type GeoUnits } from '~/store/boundaries/boundaries.repository';
import {
  type BoundaryId, type BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';

export enum BoundaryGroupFromAIModalSteps {
  Name = 'Name',
  BuildingBlock = 'BuildingBlock',
  Variables = 'Variables',
  AdditionalOptions = 'AdditionalOptions',
}

export interface MetricValue {
  id: string;
  groupId?: string;
  name: string;
  checked: boolean;
  weight: number;
  isConstraint: boolean;
  constraintLowerBound?: number;
  constraintUpperBound?: number;
  numericPercent?: number;
}

export type AdditionalOptionConstraints = Readonly<{
  isConstraint?: boolean;
  maxConstraint?: number;
  minConstraint?: number;
}>;

export interface GlobalMetricValue {
  id: string;
  name: string;
  weight: number;
  minWeight: number;
  maxWeight: number;
}

export enum BuildingBlockSelection {
  ALL = 'ALL',
  SUBSET = 'SUBSET'
}

export enum BuildingBlockSubsetType {
  FROM_DATA = 'from-data',
  ON_MAP = 'on-map',
}

export type SalesRepLocationsMap = Readonly<{
  mapId: number;
  spreadsheetId: number;
}>;

export type CreateBoundaryGroupFromAIConfig = Readonly<{
  allStates: boolean;
  applyFilterOnData: boolean;
  buildingBlock: GeoUnits | null;
  buildingBlockSelection: BuildingBlockSelection;
  buildingBlockSubsetType: BuildingBlockSubsetType;
  dataMetricsValues: readonly MetricValue[];
  demographicsValues: readonly MetricValue[];
  groupName: string;
  numberOfPreviousTerritories: number | null;
  numberOfSalesReps: number | null;
  numberOfTerritories: number | null;
  optimizationConstraints: boolean;
  overrideTerritory: boolean;
  previouslySavedBoundaryGroupId: BoundaryTerritoryGroupId | null;
  respectPrevTerritories: boolean;
  respectSalesLocations: boolean;
  salesRepLocationsMap: SalesRepLocationsMap | null;
  salesRepNameColumnId: string | null;
  selectedBoundaryIds: readonly BoundaryId[];
  useNumberOfTerritories: boolean;
  statesSubset?: string[];
  zipCodesSubset?: string[];
}>;

export enum NumberOfTerritoriesLastUpdateReason {
  Other = 'Other',
  ManualEdit = 'ManualEdit',
  RespectPreviousTerritoriesChange = 'RespectPreviousTerritoriesChange',
  SalesRepLocationsMapIdChange = 'SalesRepLocationsMapIdChange',
}
